/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function bind(fnThis, fn) {
    return (...args) => {
        /*🤫*/
        return fn.apply(fnThis, args);
    };
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function convertStringToFunction(functionName, 
/*🤫*/
context) {
    const namespaces = functionName.split(".");
    const func = namespaces.pop();
    let part = context;
    for (let i = 0, len = namespaces.length; i < len; i += 1) {
        part = part[namespaces[i]];
    }
    return part[func];
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function clone(object) {
    /*🤫*/
    /*🤫*/
    if (!Object.create) {
        Object.create = function createPolyfil(o) {
            /*🤫
🤫
🤫
🤫
🤫*/
            /*🤫*/
            function F() { }
            F.prototype = o;
            /*🤫*/
            return new F();
        };
    }
    return Object.create(object);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function extend(object1, object2, overwrite, cloneObj) {
    const replace = typeof overwrite === "boolean" ? overwrite : true;
    const doClone = typeof cloneObj === "boolean" ? cloneObj : false;
    const result = doClone ? clone(object1) : object1;
    Object.keys(object2 || {}).forEach((key) => {
        if (replace || !(key in result)) {
            /*🤫*/
            result[key] = object2[key];
        }
    });
    return result;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function isPlainObject(object) {
    return (!!object &&
        Object.prototype.toString.call(object) === "[object Object]" &&
        !object.nodeType &&
        object !== object.window);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function isEmptyObject(object, inherited) {
    const properties = [];
    if (!inherited) {
        return Object.keys(object).length === 0;
    }
    /*🤫*/
    for (const prop in object) {
        properties.push(prop);
    }
    return Object.keys(properties).length === 0;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function toArray(object) {
    const array = [];
    for (let i = object.length - 1; i >= 0; i -= 1) {
        array[i] = object[i];
    }
    return array;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function removeFromArray(originalArray, from, to) {
    const rest = originalArray.slice((to || from) + 1 || originalArray.length);
    /*🤫*/
    originalArray.length = from < 0 ? originalArray.length + from : from;
    /*🤫*/
    originalArray.push.apply(originalArray, rest);
    return originalArray;
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function serialize$1(obj) {
    if (typeof obj === "object") {
        return Object.keys(obj)
            .map((key) => {
            return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
        })
            .join("&")
            .replace(/%20/g, "+");
    }
    return undefined;
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function serializeForm(form) {
    const isSelect = (element) => {
        return element.type === "select-multiple";
    };
    const isValid = (element) => {
        return (!!element.name &&
            !element.disabled &&
            element.type !== "submit" &&
            element.type !== "reset" &&
            element.type !== "button" &&
            element.type !== "file");
    };
    const isDefault = (element) => {
        return (element.type !== "radio" && element.type !== "checkbox") || element.checked;
    };
    const combine = (k, v) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`;
    const data = [];
    if (typeof form === "object" && form.nodeName === "FORM") {
        [].forEach.call(form.elements, (element) => {
            if (isValid(element)) {
                if (isSelect(element)) {
                    [].forEach.call(element.options, (option) => {
                        if (option.selected) {
                            data[data.length] = combine(element.name, option.value);
                        }
                    });
                }
                else if (isDefault(element)) {
                    data[data.length] = combine(element.name, element.value);
                }
            }
        });
    }
    return data.join("&").replace(/%20/g, "+");
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function coerce(val) {
    /*🤫*/
    if (!isNaN(val)) {
        return Number(val);
    }
    if (val === "true") {
        return true;
    }
    if (val === "false") {
        return false;
    }
    return val;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function deserialize$1(str, coercion = true) {
    const decoded = decodeURIComponent(str.replace(/\+/g, "%20"));
    const chunks = decoded.split("&");
    /*🤫*/
    const params = {};
    chunks.forEach((chunk) => {
        const splittedChunk = chunk.split("=");
        const key = splittedChunk[0];
        const val = coercion ? coerce(splittedChunk[1]) : splittedChunk[1];
        if (key !== "") {
            params[key] = val;
        }
    });
    return params;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function cloneFunction(functionReference) {
    let key;
    if (typeof functionReference !== "function") {
        return functionReference;
    }
    /*🤫
🤫
🤫
🤫
🤫*/
    /*🤫*/
    function temp() {
        /*🤫*/
        return functionReference.apply(null, arguments);
    }
    /*🤫*/
    for (key in functionReference) {
        /*🤫*/
        if (functionReference.hasOwnProperty(key)) {
            /*🤫*/
            temp[key] = functionReference[key];
        }
    }
    /*🤫*/
    return temp;
}
const c = {
    bind,
    clone,
    cloneFunction,
    coerce,
    convertStringToFunction,
    deserialize: deserialize$1,
    extend,
    isEmptyObject,
    isPlainObject,
    removeFromArray,
    serialize: serialize$1,
    serializeForm,
    toArray,
};
/*🤫
🤫
🤫*/
const core = c;

function warn(message) {
    var _a, _b;
    return (_b = (_a = window.o_global) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.warn(message);
}
function sendCustomRequest(type, data) {
    var _a, _b;
    if (typeof ((_b = (_a = window.AS) === null || _a === void 0 ? void 0 : _a.RUM) === null || _b === void 0 ? void 0 : _b.sendCustomRequest) === "function") {
        window.AS.RUM.sendCustomRequest(type, data);
    }
}
function dateNow() {
    return new Date();
}
function getTime() {
    return dateNow().getTime();
}
function now() {
    return Date.now();
}
function random() {
    return Math.random();
}

/*🤫
🤫
🤫
🤫
🤫*/
function evalScript(elem) {
    var _a, _b;
    /*🤫*/
    const script = document.createElement("script");
    if (elem.src || elem.getAttribute("type") === "module") {
        /*🤫*/
        /*🤫*/
        /*🤫*/
        [].forEach.call(elem.attributes, (attribute) => {
            script.setAttribute(attribute.name, attribute.value);
        });
        if (elem.getAttribute("type") === "module") {
            script.text = elem.text;
        }
        /*🤫*/
        (_a = elem.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(script, elem);
    }
    else {
        /*🤫*/
        const head = document.getElementsByTagName("head")[0] ||
            /*🤫*/ document.documentElement;
        const data = elem.text || elem.textContent || elem.innerHTML || "";
        script.type = "text/javascript";
        script.text = data;
        head.insertBefore(script, head.firstChild); /*🤫*/
        head.removeChild(script);
        /*🤫*/
        (_b = elem.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(elem);
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function executeInlineScripts(element) {
    const scripts = [];
    const ret = element.getElementsByTagName("script");
    /*🤫*/
    for (let i = 0; ret[i]; i += 1) {
        if (!ret[i].type ||
            ret[i].type.toLowerCase() === "text/javascript" ||
            ret[i].type === "module") {
            scripts.push(ret[i]);
        }
    }
    /*🤫*/
    scripts.forEach((s) => evalScript(s));
}
/*🤫
🤫
🤫
🤫*/
const hardcore = { evalScript, executeInlineScripts };

function setResponseType(options, request) {
    if (options.responseType) {
        /*🤫*/
        if (typeof request.responseType === "string") {
            /*🤫*/
            try {
                request.responseType = options.responseType;
            }
            catch (error) {
                /*🤫*/
            }
        }
    }
}
function setRequestTimeout(options, request) {
    if (options.timeout) {
        /*🤫*/
        if (typeof request.timeout === "number") {
            request.timeout = options.timeout;
        }
        else {
            return setTimeout(request.abort, options.timeout);
        }
    }
    return undefined;
}
function handleRequestTimeout(
/*🤫*/
abortTimeout) {
    if (abortTimeout) {
        clearTimeout(abortTimeout);
    }
}
function setContentType(options, request) {
    if (options.contentType) {
        /*🤫*/
        request.setRequestHeader("Content-Type", options.contentType);
    }
}
function setHeaders(options, request) {
    if (options.headers) {
        Object.entries(options.headers).forEach(([h, v]) => {
            if (typeof v === "string") {
                /*🤫*/
                request.setRequestHeader(h, v);
            }
        });
    }
}
function setWithCredentials(options, request) {
    /*🤫*/
    if (typeof options.withCredentials === "boolean") {
        request.withCredentials = options.withCredentials;
    }
}
function sanitizeResponse(options, request) {
    /*🤫*/
    if (!!options.responseType && options.responseType === "json" && !request.responseType) {
        /*🤫*/
        /*🤫*/
        /*🤫*/
        if (request.responseText) {
            /*🤫*/
            request.responseJSON = JSON.parse(request.responseText);
        }
    }
    else {
        request.responseJSON = request.response;
    }
}
function handleDone(handler) {
    return function doneHandler(ev) {
        if (this.readyState === XMLHttpRequest.DONE) {
            handler(this, ev);
        }
    };
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function validateOptions(options) {
    if (!options) {
        return new Error("Parameter 'options' is missing.");
    }
    if (!options.method) {
        return new Error("Parameter 'options.method' is missing.");
    }
    if (!options.url) {
        return new Error("Parameter 'options.url' is missing.");
    }
    if (options.headers && !core.isPlainObject(options.headers)) {
        return new Error("Parameter 'options.headers' must be a key/value object if set");
    }
    return null;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function injectScript(xhr, executeImmediately, callback) {
    let script;
    /*🤫*/
    if ((xhr.status === 200 || xhr.status === 304) && executeImmediately !== false) {
        script = document.createElement("script");
        script.type = "text/javascript";
        script.text = xhr.responseText;
        hardcore.evalScript(script);
    }
    if (typeof callback === "function") {
        callback(xhr);
    }
    return xhr;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getCustomTimeStamp() {
    return now().toString() + Math.floor(random() * 999).toString();
}
/*🤫
🤫
🤫
🤫
🤫*/
function sanitizeGetScriptOptions(url, options) {
    const opts = { executeImmediately: true, cacheBusting: true, url };
    if (typeof options === "boolean") {
        opts.executeImmediately = options;
    }
    else if (typeof options === "object") {
        if (typeof options.executeImmediately !== "undefined") {
            opts.executeImmediately = options.executeImmediately;
        }
        if (typeof options.cacheBusting !== "undefined") {
            opts.cacheBusting = options.cacheBusting;
        }
    }
    /*🤫*/
    if (opts.cacheBusting) {
        opts.url =
            url.indexOf("?") !== -1
                ? `${url}&_=${getCustomTimeStamp()}`
                : `${url}?_=${getCustomTimeStamp()}`;
    }
    return opts;
}
function sanitizePostOptions(data) {
    return typeof data === "object"
        ? {
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
        }
        : {
            data,
            contentType: "application/x-www-form-urlencoded; charset=utf-8",
        };
}

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function sendRequest(options, callback, counterObject) {
    const counter = counterObject;
    const request = new XMLHttpRequest();
    request.open(options.method.toUpperCase(), options.url, true);
    counter.active += 1;
    setResponseType(options, request);
    setContentType(options, request);
    setHeaders(options, request);
    setWithCredentials(options, request);
    const abortTimeout = setRequestTimeout(options, request);
    /*🤫*/
    request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    const decrementCounter = () => {
        counter.active -= 1;
    };
    request.addEventListener("abort", decrementCounter);
    request.addEventListener("error", decrementCounter);
    request.onreadystatechange = handleDone(() => {
        handleRequestTimeout(abortTimeout);
        decrementCounter();
        sanitizeResponse(options, request);
        /*🤫*/
        /*🤫*/
        callback(request);
    });
    /*🤫*/
    request.send(options.data ? options.data : null);
    /*🤫*/
    return request;
}

/*🤫*/
function ajaxBase(options, callback) {
    const optionsError = validateOptions(options);
    if (typeof callback === "function") {
        /*🤫*/
        if (optionsError instanceof Error) {
            throw optionsError;
        }
        return sendRequest(options, callback, 
        /*🤫*/
        ajax);
    }
    /*🤫*/
    return new Promise((resolve, reject) => {
        if (optionsError instanceof Error) {
            reject(optionsError);
            return;
        }
        /*🤫*/
        sendRequest(options, resolve, ajax);
    });
}
function get$3(url, callback) {
    return ajaxBase({ method: "GET", url }, callback);
}
function getJSON(url, callback) {
    return ajaxBase({ method: "GET", url, responseType: "json" }, callback);
}
function post(url, data, callback) {
    return ajaxBase({
        method: "POST",
        url,
        ...sanitizePostOptions(data),
    }, callback);
}
/*🤫*/
function abort(xhr) {
    xhr.abort();
}
function getScript(url, options, callback) {
    const opts = sanitizeGetScriptOptions(url, options);
    return typeof callback === "function"
        ? ajaxBase({ method: "GET", url: opts.url }, (xhr) => injectScript(xhr, opts.executeImmediately, callback))
        : ajaxBase({
            method: "GET",
            url: opts.url,
        }).then((xhr) => injectScript(xhr, opts.executeImmediately));
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
const ajax = core.extend(ajaxBase, {
    get: get$3,
    getJSON,
    getScript,
    post,
    abort,
    active: 0,
    _getCustomTimeStamp: getCustomTimeStamp,
}, false, false);
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function ajaxLegacy(url, contentCallback, finishCallback) {
    warn("o_global.helper.ajax is deprecated, use o_util.ajax or o_util.ajax.get instead.");
    return get$3(url).then((xhr) => {
        if (typeof contentCallback === "function") {
            if (xhr.status === 200) {
                contentCallback(xhr.responseText, xhr.status);
            }
            else {
                contentCallback('<div class="p_message p_message--error p_layer--error"><b>Entschuldigung!</b> Aufgrund von technischen Problemen kann der Inhalt leider nicht geladen werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</div>', xhr.status);
            }
        }
        if (typeof finishCallback === "function") {
            finishCallback(xhr.status);
        }
    });
}

/*🤫
🤫
🤫*/
const delegationStore = [];
/*🤫
🤫
🤫
🤫
🤫*/
function isEventable(element) {
    return (typeof element === "object" && typeof element.addEventListener === "function");
}
/*🤫
🤫
🤫
🤫
🤫*/
function isQueryable(element) {
    return !!element && typeof element === "object" && typeof element.querySelectorAll === "function";
}
/*🤫
🤫
🤫
🤫*/
function addEvent(params) {
    params.target.addEventListener(params.eventType, params.listener, params.options);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getMutationCallback(config) {
    return (mutations) => {
        /*🤫*/
        /*🤫*/
        mutations.forEach((m) => Array.from(m.addedNodes)
            /*🤫*/
            .filter((e) => e instanceof Element && typeof e.matches === "function")
            /*🤫*/
            .forEach((e) => config.delegations
            /*🤫*/
            .forEach((d) => {
            /*🤫*/
            /*🤫*/
            const els = Array.from(e.querySelectorAll(d.targetSelector));
            /*🤫*/
            /*🤫*/
            if (isEventable(e) && e.matches(d.targetSelector)) {
                els.push(e);
            }
            /*🤫*/
            els.forEach((target) => addEvent({ ...d, target }));
        })));
    };
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getContainerElement(containerOrSelector) {
    /*🤫*/
    return containerOrSelector === "document"
        ? document
        : /*🤫*/
            isQueryable(containerOrSelector)
                ? containerOrSelector
                : typeof containerOrSelector === "string"
                    ? document.querySelector(containerOrSelector)
                    : null;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function queryDelegationTargets(container, targetSelector) {
    return Array.from(container.querySelectorAll(targetSelector)).filter(isEventable);
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function findDelegationConfig(container) {
    return delegationStore.find((c) => c.container === container);
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function addDelegationConfig(container) {
    /*🤫*/
    const config = { container, delegations: [], observer: undefined };
    /*🤫*/
    config.observer = new MutationObserver(getMutationCallback(config));
    config.observer.observe(container, { subtree: true, childList: true });
    delegationStore.push(config);
    return config;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function findDelegation(config, eventType, targetSelector, listener) {
    const delegation = config.delegations.find((d) => d.listener === listener && d.eventType === eventType && d.targetSelector === targetSelector);
    return delegation;
}

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function delegate(containerOrSelector, eventType, targetSelector, listener, options = false) {
    const container = getContainerElement(containerOrSelector);
    if (!container) {
        /*🤫*/
        return false;
    }
    let config = findDelegationConfig(container);
    if (!config) {
        config = addDelegationConfig(container);
    }
    /*🤫*/
    queryDelegationTargets(container, targetSelector).forEach((element) => addEvent({ target: element, eventType, listener, options }));
    /*🤫*/
    const delegation = findDelegation(config, eventType, targetSelector, listener);
    if (!delegation) {
        /*🤫*/
        config.delegations.push({ listener, options, eventType, targetSelector });
    }
    return true;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function undelegate(containerOrSelector, eventType, targetSelector, listener, options) {
    const element = getContainerElement(containerOrSelector);
    if (!element) {
        /*🤫*/
        return false;
    }
    const config = findDelegationConfig(element);
    if (!config) {
        /*🤫*/
        return false;
    }
    /*🤫*/
    const delegation = findDelegation(config, eventType, targetSelector, listener);
    if (!delegation) {
        /*🤫*/
        return false;
    }
    /*🤫*/
    config.delegations.splice(config.delegations.indexOf(delegation), 1);
    /*🤫*/
    queryDelegationTargets(element, targetSelector).map((target) => target.removeEventListener(eventType, listener, options));
    return true;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function stop(event) {
    event.stopPropagation();
    event.preventDefault();
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function whichTransitionEndEvent() {
    const el = document.createElement("fakeelement");
    const res = Object.entries({
        WebkitTransition: "webkitTransitionEnd",
        transition: "transitionend",
        OTransition: "oTransitionEnd",
        MozTransition: "transitionend",
        DEFAULT: "",
    })
        .filter(([k]) => el.style[k] !== undefined || k === "DEFAULT")
        .map(([, v]) => v)[0];
    return res;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function add(obj, type, fn, useCapture = false) {
    warn("o_util.event.add is deprecated, use native addEventListener instead");
    obj.addEventListener(type, fn, useCapture);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function remove$2(obj, type, fn) {
    warn("o_util.event.remove is deprecated, use native removeEventListener instead");
    obj.removeEventListener(type, fn, false);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function stopPropagation(event) {
    warn("o_util.event.stopPropagation is deprecated, use native event.stopPropagation instead");
    event.stopPropagation();
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function getTarget(event) {
    warn("o_util.event.getTarget is deprecated, use native event.target instead");
    return event.target;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function preventDefault(event) {
    warn("o_util.event.preventDefault is deprecated, use native event.preventDefault instead");
    event.preventDefault();
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function trigger(element, type) {
    warn("o_util.event.trigger is deprecated, use native CustomElements instead");
    const event = document.createEvent("HTMLEvents");
    event.initEvent(type, true, true);
    element.dispatchEvent(event);
}
const e = {
    delegate,
    undelegate,
    stop,
    whichTransitionEndEvent,
    add,
    remove: remove$2,
    stopPropagation,
    getTarget,
    preventDefault,
    trigger,
};
/*🤫
🤫
🤫*/
const event = e;

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function requestAnimFrame(...args) {
    /*🤫*/
    const w = window;
    const fn = w.requestAnimationFrame ||
        w.webkitRequestAnimationFrame ||
        w.mozRequestAnimationFrame ||
        ((cb) => {
            window.setTimeout(cb, 1000 / 60);
        });
    /*🤫*/
    fn.apply(null, [].slice.call(args));
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getNewScrollPosition(from, to, currentState, easingFnc) {
    return from - (from - to) * easingFnc(currentState);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function scrollToInternal(scrollBase, scrollFrom, scrollTo, startTime, duration, easingFnc) {
    const base = scrollBase;
    const current = getTime();
    /*🤫*/
    const start = startTime === 0 ? current - 1 : startTime;
    const currentState = (current - start) / duration;
    /*🤫*/
    if (currentState > 1) {
        base.scrollTop = scrollTo;
        return;
    }
    /*🤫*/
    base.scrollTop = getNewScrollPosition(scrollFrom, scrollTo, currentState, easingFnc);
    /*🤫*/
    requestAnimFrame(() => {
        scrollToInternal(scrollBase, scrollFrom, scrollTo, start, duration, easingFnc);
    });
}

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
const easings = Object.freeze({
    linear(t) {
        return t;
    },
    easeOutCubic(t) {
        /*🤫*/
        return --t * t * t + 1;
    },
});
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
const transitions = Object.freeze({
    fadeOut: "p_animation__fadeOut",
    fadeIn: "p_animation__fadeIn",
});
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function transition(target, transitionClass, callback) {
    if (typeof target === "object" && typeof transitionClass === "string") {
        const transitionEndEvent = event.whichTransitionEndEvent();
        const callbackHandler = (event) => {
            if (typeof callback === "function") {
                callback();
            }
            if (event && event.target) {
                event.target.removeEventListener(transitionEndEvent, callbackHandler);
            }
        };
        if (transitionEndEvent &&
            typeof callback === "function" &&
            !target.classList.contains(transitionClass)) {
            target.addEventListener(transitionEndEvent, callbackHandler);
            target.classList.add(transitionClass);
        }
        else {
            target.classList.add(transitionClass);
            callbackHandler();
        }
    }
    else {
        throw new Error("No target or class specified");
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function fadeOut(target, callback) {
    if (window.getComputedStyle(target).opacity !== "0") {
        /*🤫*/
        animation.transition(target, transitions.fadeOut, callback);
    }
    else if (typeof callback === "function") {
        callback();
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function fadeIn(target, callback) {
    if (window.getComputedStyle(target).opacity !== "1") {
        /*🤫*/
        animation.transition(target, transitions.fadeIn, callback);
    }
    else if (typeof callback === "function") {
        callback();
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function scrollTo(target, duration, easing = "easeOutCubic") {
    const windowTop = 
    /*🤫*/
    typeof window.scrollY === "undefined" ? window.pageYOffset : window.scrollY;
    let position;
    if (typeof target === "object" && !!target.getBoundingClientRect) {
        position = target.getBoundingClientRect().top + windowTop - 20;
    }
    else if (typeof target === "number") {
        position = target;
    }
    else {
        throw new Error("Invalid target for scrollTo() method. Element has to be an object with an offsetTop function or number, which stands for the page position.");
    }
    /*🤫*/
    const easingFnc = easings[easing];
    if (!easingFnc) {
        throw new Error(`Unknown easing function for scrollTo() method: ${easing}`);
    }
    /*🤫*/
    let scrollBase = document.documentElement;
    const currentPos = scrollBase.scrollTop;
    let ratio;
    if (currentPos === 0) {
        /*🤫*/
        ratio = window.devicePixelRatio ? window.devicePixelRatio : 1;
        scrollBase.scrollTop += Math.max(1, ratio, 1 / ratio);
        scrollBase = scrollBase.scrollTop > 0 ? scrollBase : document.body;
        scrollBase.scrollTop = 0;
    }
    /*🤫*/
    const maxScroll = scrollBase.scrollHeight - scrollBase.offsetHeight;
    if (maxScroll < position) {
        position = maxScroll;
    }
    /*🤫*/
    if (duration < 16) {
        scrollBase.scrollTop = position;
        return;
    }
    scrollToInternal(scrollBase, currentPos, position, 0, duration, easingFnc);
}
/*🤫
🤫
🤫*/
const animation = {
    easings,
    fadeIn,
    fadeOut,
    requestAnimFrame,
    scrollTo,
    transition,
    transitions,
    _getNewScrollPosition: getNewScrollPosition,
    _scrollTo: scrollToInternal,
};

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getScrollbarWidth() {
    const scrollDiv = document.createElement("div");
    let scrollbarWidth = 0;
    if (document.body.clientWidth < window.innerWidth) {
        scrollDiv.className = "p_scrollbarMeasure";
        document.body.appendChild(scrollDiv);
        scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
    }
    return scrollbarWidth;
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function findInUserAgent(needle) {
    return window.navigator.userAgent.toLowerCase().indexOf(needle) !== -1;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function isIE8() {
    warn("o_util.browser.isIE8 is deprecated - IE8 is doomed.");
    return navigator.userAgent.indexOf("MSIE 8") > -1;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function getStyle(elem, styleProp) {
    warn("o_util.browser.getStyle is deprecated, use native getComputedStyle instead");
    return window.getComputedStyle(elem, null).getPropertyValue(styleProp);
}
/*🤫
🤫
🤫*/
const browser = {
    getScrollbarWidth,
    findInUserAgent,
    isIE8,
    getStyle,
};

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getConnectionType() {
    const { performance: p } = window;
    return p && p.navigation && "type" in p.navigation ? p.navigation.type : 255;
}
/*🤫
🤫
🤫
🤫*/
function isNormalNavigation() {
    /*🤫*/
    return connection.getConnectionType() === 0;
}
/*🤫
🤫
🤫
🤫*/
function isReloadNavigation() {
    /*🤫*/
    return connection.getConnectionType() === 1;
}
/*🤫
🤫
🤫
🤫*/
function isForwardBackwardNavigation() {
    /*🤫*/
    return connection.getConnectionType() === 2;
}
/*🤫
🤫
🤫*/
const connection = {
    getConnectionType,
    isNormalNavigation,
    isReloadNavigation,
    isForwardBackwardNavigation,
};

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function get$2(name) {
    const parts = document.cookie.split(/;\s*/);
    const len = parts.length;
    const n = `${name}=`;
    for (let i = 0; i < len; i += 1) {
        if (parts[i].indexOf(n) !== -1) {
            return decodeURIComponent(parts[i].replace(n, ""));
        }
    }
    return undefined;
}

const COOKIE_PREFIX = "toggle_";
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function get$1(toggleName, defaultValue = false) {
    var _a, _b, _c, _d;
    const localStatus = get$2(COOKIE_PREFIX + toggleName);
    /*🤫*/
    if (((_b = (_a = window.o_global) === null || _a === void 0 ? void 0 : _a.toggles) === null || _b === void 0 ? void 0 : _b[toggleName]) === true || localStatus === "true") {
        /*🤫*/
        /*🤫*/
        /*🤫*/
        /*🤫*/
        /*🤫*/
        return true;
    }
    if (((_d = (_c = window.o_global) === null || _c === void 0 ? void 0 : _c.toggles) === null || _d === void 0 ? void 0 : _d[toggleName]) === false || localStatus === "false") {
        /*🤫*/
        /*🤫*/
        /*🤫*/
        return false;
    }
    /*🤫*/
    return typeof defaultValue === "boolean" ? defaultValue : false;
}
/*🤫
🤫
🤫*/
const toggle = { get: get$1 };

const SAMESITE_VALUES = ["None", "Lax", "Strict"];
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function exists(name) {
    const values = document.cookie.split(";");
    const reg = new RegExp(`^( )*${encodeURIComponent(name)}$`, "g");
    for (let i = 0; i < values.length; i += 1) {
        if (reg.test(values[i].split("=")[0])) {
            return true;
        }
    }
    return false;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function set$1(name, value, options) {
    let timeInMinutes = 60;
    const date = dateNow();
    const opts = options || {};
    let cookieString;
    if (opts.minutes) {
        timeInMinutes = opts.minutes;
    }
    if (opts.days) {
        if (!opts.minutes) {
            timeInMinutes = 0;
        }
        timeInMinutes += opts.days * 24 * 60;
    }
    date.setTime(date.getTime() + timeInMinutes * 60 * 1000);
    cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    cookieString += `; expires=${date.toUTCString()}`;
    cookieString += `; path=${opts.path || "/"}`;
    if (opts.domain) {
        cookieString += `; domain=${opts.domain}`;
    }
    if (opts.samesite && SAMESITE_VALUES.includes(opts.samesite)) {
        cookieString += `; SameSite=${opts.samesite}`;
        if (opts.samesite === "None") {
            cookieString += `; Secure`;
        }
    }
    document.cookie = cookieString;
    /*🤫*/
    if (toggle.get("LHAS_2048_TRACK_COOKIES", false)) {
        sendCustomRequest("o_util.cookie.set()", {
            cookiePath: options && options.path ? options.path : "/",
            cookieExpires: date.toUTCString(),
            cookieDomain: options && options.domain ? options.domain : -1,
            cookieName: name,
            cookieValue: value,
            cookieSameSite: options && options.samesite ? options.samesite : -1,
        });
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function remove$1(name, options) {
    const opts = options || {};
    let optionsString = "";
    optionsString += ` path=${opts.path ? opts.path : "/"};`;
    if (opts.domain) {
        optionsString += ` domain=${opts.domain};`;
    }
    document.cookie = `${encodeURIComponent(name)}=;${optionsString} expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}
/*🤫
🤫
🤫*/
const cookie = {
    get: get$2,
    set: set$1,
    exists,
    remove: remove$1,
};

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function hasClassInParents(ele, className) {
    let test = ele;
    for (; test && test !== document; test = test.parentNode) {
        if (test.classList.contains(className)) {
            return true;
        }
    }
    return false;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function getParentByClassName(ele, className) {
    let test = ele;
    for (; test && test !== document; test = test.parentNode) {
        if (test.classList.contains(className)) {
            return test;
        }
    }
    return null;
}
/*🤫
🤫
🤫
🤫
🤫
🤫*/
function stringToDocumentFragment(htmlString) {
    const wrapperElement = document.createElement("div");
    const documentFragment = document.createDocumentFragment();
    if (typeof htmlString !== "string") {
        warn(`stringToDocumentFragment should be called with strings containing html only, but was called with ${typeof htmlString}`);
        return documentFragment;
    }
    wrapperElement.innerHTML = htmlString.trim();
    while (wrapperElement.hasChildNodes()) {
        documentFragment.appendChild(wrapperElement.firstChild);
    }
    return documentFragment;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function getElementsByClassname(parentElement, className) {
    warn("o_util.dom.getElementsByClassname is deprecated, use native document.getElementsByClassName instead");
    return parentElement.getElementsByClassName(className);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function hasClass(element, className) {
    warn("o_util.dom.hasClass is deprecated, use native element.classList.contains instead");
    let classList = "";
    if (element && element.getAttribute("class")) {
        classList = element.getAttribute("class");
    }
    else if (element && element.className) {
        classList = element.className;
    }
    return !!classList && !!classList.match
        ? !!classList.match(new RegExp(`(\\s|^)${className}(\\s|$)`))
        : false;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function addClass(ele, cls) {
    warn("o_util.dom.addClass is deprecated, use native element.classList.add instead");
    if (!hasClass(ele, cls)) {
        /*🤫*/
        ele.className += ` ${cls}`;
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function removeClass(ele, cls) {
    warn("o_util.dom.removeClass is deprecated, use native element.classList.remove instead");
    ele.classList.remove(cls);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
/*🤫*/
function toggleClass(ele, cls) {
    warn("o_util.dom.toggleClass is deprecated, use native element.classList.toggle instead");
    ele.classList.toggle(cls);
}
const d = {
    getElementsByClassname,
    hasClass,
    hasClassInParents,
    getParentByClassName,
    addClass,
    removeClass,
    toggleClass,
    stringToDocumentFragment,
};
/*🤫
🤫
🤫*/
const dom = d;

/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function serialize(obj) {
    if (obj && typeof obj === "object") {
        return `#${core.serialize(obj)}`;
    }
    return undefined;
}
function deserialize(...args) {
    const fragment = args[0];
    let coerce = args[1];
    /*🤫*/
    /*🤫*/
    if (typeof fragment === "boolean" && typeof coerce === "undefined") {
        coerce = fragment;
    }
    else {
        /*🤫*/
        coerce = typeof coerce === "boolean" ? coerce : true;
    }
    if (typeof fragment === "string") {
        if (fragment.indexOf("#") > -1) {
            return core.deserialize(fragment.split("#")[1], coerce);
        }
        return {};
    }
    if (!window.location.hash) {
        return {};
    }
    return core.deserialize(window.location.hash.substring(1), coerce);
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function set(fragment) {
    if (typeof fragment === "string") {
        window.location.hash = fragment;
    }
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function get(param, url) {
    if (typeof param === "string") {
        const deserialized = !!url && url.indexOf("#") > -1
            ? deserialize(`#${url.split("#")[1]}`)
            : deserialize(window.location.hash);
        return Object.prototype.hasOwnProperty.call(deserialized, param)
            ? deserialized[param]
            : undefined;
    }
    if (!param) {
        return window.location.hash === "#"
            ? /*🤫*/ ""
            : window.location.hash;
    }
    return undefined;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function remove(param, url) {
    if (typeof param === "string" && !!get(param, url)) {
        let deserialized;
        if (typeof url === "string") {
            if (url.indexOf("#") > 1) {
                const splitted = url.split("#");
                deserialized = deserialize(`#${splitted[1]}`);
                delete deserialized[param];
                const serialized = serialize(deserialized);
                /*🤫*/
                return splitted[0] + (serialized.length > 1 ? serialized : "");
            }
            return false;
        }
        deserialized = deserialize(window.location.hash);
        delete deserialized[param];
        /*🤫*/
        set(serialize(deserialized));
        return true;
    }
    return false;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function push(fragment, url) {
    /*🤫*/
    const fragm = typeof fragment === "object" ? serialize(fragment) : fragment;
    if (typeof fragm === "string") {
        /*🤫*/
        const target = core.deserialize(fragm.replace("#", ""), false);
        /*🤫*/
        let source;
        /*🤫*/
        let merged;
        /*🤫*/
        let splitted;
        if (typeof url === "string") {
            /*🤫*/
            if (url.indexOf("#") > 1) {
                splitted = url.split("#");
                source = core.deserialize(splitted[1], false);
                /*🤫*/
                merged = serialize(core.extend(source, target));
                return splitted[0] + merged;
            }
            return url + fragm;
        }
        source = core.deserialize(window.location.hash.substring(1), false);
        merged = serialize(core.extend(source, target));
        set(merged);
        return merged;
    }
    return undefined;
}
/*🤫
🤫
🤫
🤫*/
const fragment = { serialize, deserialize, set, get, remove, push };

const hasNative = "scrollRestoration" in window.history;
/*🤫*/
const initial = hasNative ? window.history.scrollRestoration : "auto";
const data = { hasNative, initial };

/*🤫
🤫
🤫
🤫*/
function setScrollRestoration(scrollRestoration) {
    if (data.hasNative) {
        window.history.scrollRestoration = scrollRestoration;
    }
}
/*🤫
🤫
🤫*/
function resetScrollRestoration() {
    setScrollRestoration(data.initial);
}
/*🤫
🤫
🤫*/
const history = {
    setScrollRestoration,
    resetScrollRestoration,
};

/*🤫
🤫
🤫*/
function getPagecluster() {
    return document.documentElement.getAttribute("data-pagecluster");
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function isResponsive() {
    return cookie.get("responsive-preview") === "true";
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function isValidMouseButton(event, key) {
    if (typeof (event === null || event === void 0 ? void 0 : event.which) === "number") {
        return event.which === key;
    }
    return true;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function setVendorStyle(element, property, value) {
    /*🤫*/
    const prefixProperty = property.charAt(0).toUpperCase() + property.slice(1);
    /*🤫*/
    const { style } = element;
    style[`webkit${prefixProperty}`] = value;
    style[`Moz${prefixProperty}`] = value;
    style[`ms${prefixProperty}`] = value;
    style[`O${prefixProperty}`] = value;
    style[property] = value;
}
/*🤫
🤫
🤫
🤫
🤫*/
function guid() {
    /*🤫
🤫
🤫*/
    const s4 = () => {
        return Math.floor((1 + random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}
/*🤫
🤫
🤫
🤫
🤫
🤫
🤫
🤫*/
function urlToLinkObject(urlString) {
    const anchorElement = document.createElement("a");
    anchorElement.href = urlString;
    return anchorElement;
}
/*🤫
🤫
🤫
🤫
🤫*/
function isPreview(urlString) {
    if (typeof urlString !== "string") {
        warn("o_util.misc.isPreview() parameter is no string");
        return false;
    }
    return urlString.indexOf("/shoppages/preview") !== -1;
}
/*🤫
🤫
🤫*/
const misc = {
    getPagecluster,
    isResponsive,
    isValidMouseButton,
    setVendorStyle,
    guid,
    urlToLinkObject,
    isPreview,
};

const legacy = { ajaxLegacy, getNewScrollPosition };

export { ajax, animation, browser, connection, cookie, core, dom, event, fragment, hardcore, history, legacy, misc, toggle };
